var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "green-operation-letter__history" },
    [
      _vm.isTenant && _vm.isUnderReview
        ? _c(
            "HKLLeftRight",
            {
              staticClass:
                "green-operation-letter__history-item row align-middle align-spaced",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "green-operation-letter-comments__title font-bold",
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "tenancy.greenOperation.sustainabilityPartnershipProgramme"
                        )
                      ) +
                      "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "tip" }, [
                _c("span", { staticClass: "tip__text" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("tenantProjects.submission.comment.underReview")
                    )
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.completedLetters.length
        ? [
            _vm._l(_vm.completedLetters, function (item, index) {
              return _c(
                "HKLLeftRight",
                {
                  key: index,
                  staticClass:
                    "green-operation-letter__history-item align-middle",
                },
                [
                  _c("div", {
                    staticClass: "green-operation-letter__history-title",
                    domProps: { innerHTML: _vm._s(item.title) },
                    on: {
                      click: function () {
                        return _vm.openPreviousHistory(item)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("HKLGrayHint", { attrs: { fontSize: 11 } }, [
                    _vm._v("\n        " + _vm._s(item.tipWording) + "\n      "),
                  ]),
                ],
                1
              )
            }),
            _vm._v(" "),
            _c("GreenOperationPreviewSendModal", {
              ref: "previewSendModal",
              attrs: { previewData: _vm.previewLetter || {} },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }